import { FontCategory } from "@/interfaces/font.interface";
import { FolderRoot } from "lucide-react";

interface Props {
  data: FontCategory;
  selectedCategory?: FontCategory;
  onSelect?: (category?: FontCategory) => void;
}

export default function RootCategoryNode({
  data,
  selectedCategory,
  onSelect,
}: Props) {
  return (
    <div
      className={`hover:bg-primary-300 flex max-h-8 min-h-8 w-full cursor-pointer items-center gap-2 pl-2 opacity-50 hover:text-white ${selectedCategory?._id === data._id ? "bg-primary-300 text-white" : ""}`}
      onClick={() => onSelect?.(data)}
    >
      <FolderRoot size={18} />
      <span>{data.name}</span>
    </div>
  );
}
